import React, { useEffect, useRef, useState } from "react";
import "../../../incidents/cases/addCaseList.scss";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../../library/custom/button/Button";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import { GRID_DEFAULT_PAGE_SIZE, ROW_PER_PAGE_SIZE } from "../../../../constant/constant";
import { ADD_ADMIN_GROUP } from "../../../../../src/constant/routeContant";
import DialogBox from "../../../../library/common/DialogBox";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import UserFilterList from "../../shared/UserFilterList ";
import FilterListIcon from "@mui/icons-material/FilterList";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { InactiveClient } from "../../../../utils/helper";
import { useDebounce } from "../../../../utils/useDebounceSearch";

export default function UserGroupList({
  GroupListData,
  noOfRecords,
  getuserGroupLists,
  loading,
  deleteGroup,
  isDivision = true,
  divisiondata,
  GroupListDatas,
  isShowDowdownloadButton = true,
  shouldRestoreState,
}) {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [divisionfilter, setDivisionFilter] = useState("");
  const [isTableLoading, setisTableLoading] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const fetchGroups = ({
    newPage = page,
    newPageSize = pageSize,
    newSearch = search,
    newDivision = divisionfilter,
    isSendMail = false,
  } = {}) => {
    const payload = {
      page: newPage + 1,
      pageSize: newPageSize,
      search: newSearch || "",
      divisionId: newDivision ? newDivision : 0,
      allGroups: !newDivision,
      isSendMail,
    };

    getuserGroupLists(payload);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const divisionFilterOnChanges = (e) => {
    setDivisionFilter(e.target.value);
  };
  const deletehandle = () => {
    setOpenModal(false);
    deleteGroup(selectedRow.groupId);
  };

  const handleOnclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("groupListPreserveState", "true");
    navigate(ADD_ADMIN_GROUP, {
      state: { groupId: rows.row.groupId, editMode: true },
    });
  };

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteIncidents = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };

  const navigate = useNavigate();
  const handleClickAdd = () => {
    if (InactiveClient()) return;
    navigate(ADD_ADMIN_GROUP);
  };

  const columns = [
    { field: "groupId", headerName: "Group ID", flex: 1.5 },
    { field: "value", headerName: "Group Name", flex: 2.5 },
    { field: "startDate", headerName: "Start Date", flex: 2 },
    { field: "userCount", headerName: "Users", flex: 1 },
    {
      field: "divisionName",
      headerName: "Division",
      flex: 1,
      renderCell: (rows) => {
        return (
          <>
            {rows?.row?.divisionName ? rows.row.divisionName : "All Divisions"}
          </>
        );
      },
    },
    isDivision && {
      field: "",
      width: 68,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            editOnClick={() => handleOnclick(rows)}
            deleteOnClick={() => deleteIncidents(rows?.row)}
            edit={checkPrivileges([55, 56, 12])}
            editLabel="Edit Group"
            download={false}
            viewLabel="View User"
            view={false}
            deleted={checkPrivileges([55, 12])}
            deleteLabel="Delete Group"
          />
        );
      },
    },
  ];

  useEffect(() => {
    if (shouldRestoreState && GroupListDatas?.filterObjs) {
      const f = GroupListDatas.filterObjs;
      setSearch(f.search || "");
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || GRID_DEFAULT_PAGE_SIZE);
      setDivisionFilter(f.divisionId || "");
    }
  }, [shouldRestoreState]);

  const handleautoSearch = (event) => {
    const value = event.target.value;
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);

    setSearch(value);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);

    fetchGroups({
      newPage,
    });
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);

    fetchGroups({
      newPage: 0,
      newPageSize,
    });
  };

  const handleClear = () => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    setAnchorEl(null);
    setDivisionFilter("");
    setSearch("");
    window.close();
    fetchGroups({
      newPage: 0,
      newPageSize: GRID_DEFAULT_PAGE_SIZE,
      newSearch: "",
      newDivision: "",
    });
  };
  const handleApply = () => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    setAnchorEl(null);
    window.close();

    fetchGroups({
      newPage: 0,
      newDivision: divisionfilter,
    });
  };

  const sendEmail = () => {
    fetchGroups({
      isSendMail: true,
    });
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    fetchGroups({
      newPage: 0,
      newSearch: debouncedSearch?.trim(),
    });
  }, [debouncedSearch]);

  return (
    <>
      <section className="grid_main_sec">
        {isDivision && (
          <div className="grid_main_header two_grid">
            <div className="grid_heading_style">Users Groups</div>
            {openModal && (
              <DialogBox
                open={openModal}
                rows={[]}
                header={"Confirm Deletion"}
                deletehandle={deletehandle}
                handleCloseModal={() => setOpenModal(false)}
                content={"Are you sure you want to delete this Group?"}
                view
              />
            )}

            <div>
              <div className="filter_btn">
                {checkPrivileges([12, 55, 56]) && (
                  <Buttons
                    id="btnAddGroup"
                    label={"Add Group"}
                    varientAddIconBlue={true}
                    onClick={(e) => handleClickAdd()}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                    />
                  </div>
                </label>
              </div>
              {isDivision && (
                <div className="filter_btn">
                  <button
                    aria-describedby={id}
                    variant="contained"
                    type="button"
                    name="btn"
                    onClick={(e) => handleClick(e)}
                  >
                    <FilterListIcon id="icn" /> Filters
                  </button>
                  <UserFilterList
                    firstLabel="Division"
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    handleApply={handleApply}
                    handleClear={handleClear}
                    firstLebelFilter={divisiondata}
                    resetBtn={true}
                    isShow={true}
                    firstLebelOnChanges={divisionFilterOnChanges}
                    firstLebelValue={divisionfilter}
                  />
                </div>
              )}
            </div>
            {isShowDowdownloadButton && (
              <div className="div-download-email-right" onClick={sendEmail}>
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>
            )}
          </div>
          {isTableLoading ? (
            ""
          ) : (
            <div className="desc_box row_uniq">
              <div className="table_style_ui">
                <GridTable
                  getRowId={(r) => r.groupId}
                  rows={GroupListData ?? []}
                  rowCount={noOfRecords ?? 0}
                  columns={columns}
                  loading={loading}
                  checkboxSelection={false}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
